<template>
<v-card flat>
  <v-toolbar flat>
      <v-spacer></v-spacer>
      <v-btn color="success" @click="add">Novo Tamanho</v-btn>
  </v-toolbar>
  <v-data-table
    :headers="computedHeaders"
    :items="sizes"
    disable-initial-sort
    :rows-per-page-items="[25,50,100,{'text':'$vuetify.dataIterator.rowsPerPageAll','value':-1}]"
    >
    <template v-slot:items="props">
        <td class="hidden-sm-and-down">{{ props.item.code }}</td>
        <td>{{ props.item.tamanho }}</td>
        <td class="hidden-sm-and-down">{{ props.item.description }}</td>
        <td class="text-xs-right hidden-sm-and-down">{{ price(props.item.price) }}</td>
        <td class="text-xs-right hidden-sm-and-down">{{ props.item.sabores_qtd }}</td>
        <td>
        <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
        >
            edit
        </v-icon>
        <v-icon
            small
            @click="removeSize(props.item._id)"
        >
            delete
        </v-icon>
        </td>
    </template>
  </v-data-table>
  <v-dialog v-model="formTamanho" max-width="500px">
      <v-card>
          <v-card-title>
          <span class="headline">{{ (editedIndex == -1)?"Novo Tamanho":"Editar Tamanho"}}</span>
          </v-card-title>

          <v-card-text>
          <v-container grid-list-md>
              <v-layout wrap>
              <v-flex xs12>
                  <v-text-field 
                    v-model="editedItem.tamanho" 
                    label="Nome da pizza" placeholder="Pizza Grande - 6 Fatias (30cm)"
                    autofocus v-if="formTamanho"></v-text-field>
              </v-flex>
              <v-flex xs12>
                    <v-textarea v-model="editedItem.description" label="Descrição"
                        auto-grow rows="2"
                    ></v-textarea>
              </v-flex>
              <v-flex xs12 sm6 md4>
                  <v-text-field 
                        v-model.lazy="editedItem.price" 
                        label="preço (A partir de)"
                        v-money="config"
                        ref="price"
                        prefix="R$"
                    ></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.sabores_qtd" type="number" label="Quant. de sabores"></v-text-field>
              </v-flex>
              <v-flex xs12 sm6 md4>
                  <v-text-field v-model="editedItem.code" type="number" label="Código">
                  </v-text-field>
              </v-flex>
              </v-layout>
          </v-container>
          </v-card-text>

          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="accent darken-1" flat @click="close" :disabled="loading">Cancelar</v-btn>
          <v-btn color="accent darken-1" flat @click="save" :loading="loading">Salvar</v-btn>
          </v-card-actions>
      </v-card>
  </v-dialog>
</v-card>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    props:['sizesData'],
    data(){
        return {
            config: {decimal: ',', thousands: '.', prefix: '', suffix: '', precision: 2},
            button:null,
            headers: [
                { text: 'Código', value: 'code', width:"80px",hide:"smAndDown" },
                {
                text: 'Nome',
                align: 'left',
                value: 'tamanho',
                },
                { text: 'Descrição', value: 'description',hide:'smAndDown'},
                { text: 'Preço (A partir de)', value: 'price', align: 'right', width:"80px", hide:'smAndDown'},
                { text: 'Sabores', value: 'sabores_qtd', align: 'right', width:"80px", hide:'smAndDown' },
                { text: 'Ações', value: 'actions', sortable: false, width:"90px" }
            ],
            sizes: [],
            formTamanho:false,
            tab:0,
            editedIndex: -1,
            editedItem: {
                tamanho: '',
                code: 0,
                sabores_qtd: 1,
                description: '',
                price: 0,
                enabled: true
            },
            defaultItem: {
                tamanho: '',
                code: 0,
                sabores_qtd: 1,
                description: '',
                price: 0,
                enabled: true
            },
            loading: false
        }
    },
    async mounted(){
        this.sizes = this.sizesData
    },
    watch:{
        formTamanho(val) {
            val || this.close()
        }
    },
    computed: {
        ...mapGetters([
            'typeSelected'
        ]),
        computedHeaders(){
            return this.headers.filter(h => !h.hide || !this.$vuetify.breakpoint[h.hide])
        },
        productDialog:{
            get(){
                return this.$store.state.productDialog
            },
            set(v){
                this.$store.state.productDialog = v
            }
        },
        search:{
            get(){
                return this.$store.state.search
            },
            set(value){
                if(!value)value=''
                return this.$store.state.search = value
            }
        },
    },
    methods:{
        async add(){
            this.editedItem.code = await this.$store.dispatch('generateCode')
            this.formTamanho = true
        },
        async fetchData(){
            this.sizes = await this.$store.dispatch("fetchPizzaSize")
        },
        searchAction(){
            if(this.search && this.search.trim().length >= 3 || this.search.trim().length == 0 ){
                this.$store.dispatch('fetchProducts')
                this.$store.dispatch('fetchMenu')
            }
        },
        price(v){
            return 'R$' + Number(v).toFixed(2).toString().replace('.',',')
        },
        editItem (item) {
            this.editedIndex = this.sizes.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.$refs.price.$el.getElementsByTagName('input')[0].value = item.price*100
            this.formTamanho = true
        },
        async removeSize(id){
            if(confirm('Tem certeza que deseja excluir esse tamanho?')){
                this.loading = true
                await this.$store.dispatch('removePizzaSize',id)
                this.fetchData()
                this.loading = false
            }
        },
        close () {
            this.formTamanho = false
            setTimeout(async () => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedItem.code = await this.$store.dispatch('generateCode')
                this.editedIndex = -1
            }, 300)
        },
        async save(){
            try {
                this.loading = true
                const data = JSON.parse(JSON.stringify(this.editedItem))
                data.codigo = data.code
                
                await this.$store.dispatch('addeditPizzaSize',data)
                this.fetchData()
                this.close()
                this.loading = false
            } catch (error) {
                if(error === 'O código digitado já está sendo utilizado em outro produto.'){
                    this.editedItem.code = await this.$store.dispatch('generateCode')
                    this.save()
                }else{
                    this.$toasted.show(error)
                    this.loading = false
                }
            }
        }
    }
}
</script>

<style>

</style>